<template>


	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="twelve()">竞品客户信息</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div> 

		<div class="main">
			<div class="main_title">
				<span>主要生产设备</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="payment_info el-table">
					<el-table :data="MainFrom" border>
						<el-table-column label="设备名称" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.equi_name"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="品牌（厂家）" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.equi_brand"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="规格型号" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.equi_sign"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="台数" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.equi_num"
									oninput="value=value.replace(/[^\d]/g,'')">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="购置时间" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-date-picker v-model="scope.row.equi_time" type="year" placeholder="选择年"
									value-format="yyyy">
								</el-date-picker>
								<!--          <el-date-picker v-model="scope.row.equi_time" type="date"  placeholder="选择日期"-->
								<!--                          format="yyyy"-->
								<!--                          value-format="yyyy"-->
								<!--          ></el-date-picker>-->
							</template>
						</el-table-column>
						<!--      <el-table-column label="制造能力">-->
						<!--        <template slot-scope="scope">-->
						<!--          <el-input placeholder="请输入内容"  v-model="scope.row.equi_make"></el-input>-->
						<!--        </template>-->
						<!--      </el-table-column>-->
						<!-- <el-table-column label="月产能" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.equi_cap"
									oninput="value=value.replace(/[^\d]/g,'')">
								</el-input>
							</template>
						</el-table-column> -->
						<el-table-column label="单位" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-select v-model="scope.row.equi_unit" filterable placeholder="请选择">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="keyId" v-if="false">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.keyid"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.$index,scope.row.keyid)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

				</div>
				<div class="payment_info_button">
					<button type="button" @click="addLine"><span>新增行</span></button>
					<button type="button" @click="openRate()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff" @click="addMain()"><span>保存</span></button>
					<button type="button" @click="nextTest()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getGys,
		addMain,
		delMain,
		getMain
	} from '../api/LoginApi'
	import {
		goBack,
		Transformation
	} from '../utils/Transformation'
	import {
		getThisYearMonthDays
	} from '../utils/date'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'

	export default {
		name: 'GysMainLine',
		data() {
			return {
				MainFrom: [{
					gys_no: localStorage.getItem('userName'),
					equi_name: '',
					equi_brand: '',
					equi_sign: '',
					equi_num: '',
					equi_time: null,
					equi_make: '',
					equi_cap: '',
					equi_unit: '',
					keyid: 0,
					show: true
				}],
				options: [{
						value: '套',
						label: '套'
					}, {
						value: '个',
						label: '个'
					}, {
						value: '米',
						label: '米'
					}, {
						value: '副',
						label: '副'
					},
					{
						value: '根',
						label: '根'
					}, {
						value: '支',
						label: '支'
					}, {
						value: '件',
						label: '件'
					}, {
						value: '延米',
						label: '延米'
					},
					{
						value: '平方米',
						label: '平方米'
					}, {
						value: '张',
						label: '张'
					}, {
						value: '盘',
						label: '盘'
					}, {
						value: '台',
						label: '台'
					},
					{
						value: '元',
						label: '元'
					}, {
						value: '平',
						label: '平'
					}, {
						value: '公斤',
						label: '公斤'
					}, {
						value: '卷',
						label: '卷'
					},
					{
						value: '条',
						label: '条'
					}, {
						value: '盒',
						label: '盒'
					}, {
						value: '桶',
						label: '桶'
					}, {
						value: '箱',
						label: '箱'
					},
					{
						value: '块',
						label: '块'
					}
				]
			}
		},
		created() {
			this.getMain()
		},
		mounted() {
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {
			 // 给表头加必填符号*
			addRedStar(h, { column }) {
				return [
					h("span", { style: "color: red" }, "*"),
					h("span", " " + column.label),
				];
			},
			// 查询数据
			getMain() {
				getMain(localStorage.getItem('userName')).then(res => {
					if (res.length > 0) {
						this.MainFrom = res
						// console.log('主要生产设备', res)
					}
					//获取单据状态
					getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							this.MainFrom.bill_status = res.bill_status;
						}
					});
				})
			},
			// 上一个页面
			openRate() {
				const vm = this
				vm.$router.push({
					path: '/CompetitorcustInfo'
				})
			},
			// 下一个页面
			nextTest() {
				if (this.MainFrom.bill_status != '已审核') { 
					//保存数据
					this.addMain();
					const vm = this;
					if(this.MainFrom.length > 0){
						for(var i = 0; i < this.MainFrom.length; i++){
							var item = this.MainFrom[i];
							// if (item.equi_name){
								if (!item.equi_name){
									return messageError('第'+(i+1)+'行[设备名称]不能为空!');
								}
								if (!item.equi_brand){
									return messageError('第'+(i+1)+'行[品牌（厂家）]不能为空!');
								}
								if (!item.equi_sign){
									return messageError('第'+(i+1)+'行[规格型号]不能为空!');
								}
								if (!item.equi_num){
									return messageError('第'+(i+1)+'行[台数]不能为空!');
								}
								if (!item.equi_time){
									return messageError('第'+(i+1)+'行[购置时间]不能为空!');
								}
								// if (!item.equi_make){
								// 	return messageError('第'+(i+1)+'行[制造能力]不能为空!');
								// }
								// if (!item.equi_cap){
								// 	return messageError('第'+(i+1)+'行[月产能]不能为空!');
								// }
								if (!item.equi_unit){
									return messageError('第'+(i+1)+'行[单位]不能为空!');
								}
							// }
						}
					}
				}
				const vm = this;
				// MainFrom: [{
				// 	gys_no: localStorage.getItem('userName'),
				// 	equi_name: '',
				// 	equi_brand: '',
				// 	equi_sign: '',
				// 	equi_num: '',
				// 	equi_time: null,
				// 	equi_make: '',
				// 	equi_cap: '',
				// 	equi_unit: '',
				// 	keyid: 0,
				// 	show: true
				// }],
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity '
				})
			},
			// 保存数据
			addMain: function() {
				if (this.MainFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}

				if(this.MainFrom.length > 0){
						for(var i = 0; i < this.MainFrom.length; i++){
							var item = this.MainFrom[i];
							// if (item.equi_name){
								if (!item.equi_name){
									return messageError('第'+(i+1)+'行[设备名称]不能为空!');
								}
								if (!item.equi_brand){
									return messageError('第'+(i+1)+'行[品牌（厂家）]不能为空!');
								}
								if (!item.equi_sign){
									return messageError('第'+(i+1)+'行[规格型号]不能为空!');
								}
								if (!item.equi_num){
									return messageError('第'+(i+1)+'行[台数]不能为空!');
								}
								if (!item.equi_time){
									return messageError('第'+(i+1)+'行[购置时间]不能为空!');
								}
								// if (!item.equi_make){
								// 	return messageError('第'+(i+1)+'行[制造能力]不能为空!');
								// }
								// if (!item.equi_cap){
								// 	return messageError('第'+(i+1)+'行[月产能]不能为空!');
								// }
								if (!item.equi_unit){
									return messageError('第'+(i+1)+'行[单位]不能为空!');
								}
							// }
						}
				}

				addMain(this.MainFrom, localStorage.getItem('userName')).then(res => {
					if (res.code === 200) {
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			},
			// 删除行，删除数据
			handleDelete: function(index, keyId) { // 删除行数 
				if (this.MainFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if (keyId) {
					delMain(keyId).then(res => {
						if (res.code === 200) {
							return messageSuCcEss(res.msg)
						} else {
							return messageError(res.msg)
						}
					})
				}
				this.MainFrom.splice(index, 1)
			},
			// 新增行
			addLine: function() {
				if (this.MainFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				let RateValue = {
					gys_no: localStorage.getItem('userName'),
					equi_name: '',
					equi_brand: '',
					equi_sign: '',
					equi_num: '',
					equi_time: null,
					equi_make: '',
					equi_cap: '',
					keyid: 0,
					show: true
				}
				this.MainFrom.push(RateValue)
			}
		}
	}
</script>



<style scoped>
	@import "../css/Main.css";
</style>



// WEBPACK FOOTER //
// src/componentsline/GysMainLine.vue